import { render, staticRenderFns } from "./HealthCard.vue?vue&type=template&id=3960e9bb&scoped=true&"
import script from "./HealthCard.vue?vue&type=script&lang=js&"
export * from "./HealthCard.vue?vue&type=script&lang=js&"
import style0 from "./HealthCard.vue?vue&type=style&index=0&id=3960e9bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960e9bb",
  null
  
)

export default component.exports